import { KLAGE_RAPPORT } from "../actions/klager/klageAction";
import { CreateNewReducer } from "../utils/reducerUtils";

const INITIAL_STATE = {};

const klageRapportReducer = (state = INITIAL_STATE, action) =>
  CreateNewReducer(state, action, KLAGE_RAPPORT);

export default klageRapportReducer;
